module.exports = __webpack_public_path__ + "static/media/plus-light.0b492472.svg";